import React, {useState} from "react";
import axios from "axios";
import {FlexToast, useExternalControls} from "laravel-inertia-backend";
import HelpTooltip from "../HelpTooltip.jsx";

/**
 * Schalter Brutto/Netto - eigene Schaltflächen statt eines nativen
 * <select>. Ändert die Einstellung dauerhaft über PUT
 * /cosmos/daten/entgangener-umsatz/preisgrundlage (Freigabe 22.09.2026:
 * "man könnte das ja sogar auch einstellbar machen"). Kein
 * Seiten-Neuladen, Rückmeldung per Toast; `onChanged` löst bei der
 * aufrufenden Seite ein Nachladen der Daten mit der neuen Preisgrundlage
 * aus.
 */
export default function PreisgrundlageSchalter({preisgrundlage, onChanged}) {
    const {addToast} = useExternalControls();
    const [saving, setSaving] = useState(false);

    const setzePreisgrundlage = (wert) => {
        if (wert === preisgrundlage || saving) {
            return;
        }
        setSaving(true);
        axios
            .put("/cosmos/daten/entgangener-umsatz/preisgrundlage", {preisgrundlage: wert})
            .then(({data}) => {
                onChanged(data.preisgrundlage);
                addToast(
                    <FlexToast
                        variant="success"
                        title="Entgangener Umsatz"
                        autohide
                        message={`Preisgrundlage auf ${wert === "netto" ? "netto" : "brutto"} umgestellt - gilt ab sofort für alle Betrachter.`}
                    />
                );
            })
            .catch((e) => {
                addToast(
                    <FlexToast
                        variant="danger"
                        title="Entgangener Umsatz"
                        autohide={false}
                        message={e.response?.data?.message || "Die Preisgrundlage konnte nicht geändert werden."}
                    />
                );
            })
            .finally(() => setSaving(false));
    };

    return (
        <div className="d-flex align-items-center gap-2">
            <span className="small text-muted">Preisgrundlage:</span>
            <div className="d-inline-flex align-items-stretch p-1 rounded-pill bg-body-secondary" role="group" aria-label="Preisgrundlage">
                {[
                    {id: "brutto", label: "Brutto"},
                    {id: "netto", label: "Netto"},
                ].map((item) => (
                    <button
                        key={item.id}
                        type="button"
                        disabled={saving}
                        aria-pressed={preisgrundlage === item.id}
                        className={`btn btn-sm rounded-pill border-0 ${preisgrundlage === item.id ? "bg-white text-body shadow-sm fw-semibold" : "text-body"}`}
                        style={{padding: ".3rem .9rem"}}
                        onClick={() => setzePreisgrundlage(item.id)}
                    >
                        {item.label}
                    </button>
                ))}
            </div>
            <HelpTooltip placement="right">
                Startwert ist Brutto (Vorgabe Thorsten). Eine Umstellung gilt dauerhaft für jeden, der diese Seite
                aufruft, nicht nur für die eigene Ansicht.
            </HelpTooltip>
        </div>
    );
}
